/* LUNEVAR V4: pointer depth and world colour. No dependencies, no layout writes. */
(() => {
  const html = document.documentElement;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches || html.dataset.motion === 'off';
  const fine = matchMedia('(pointer: fine)').matches;
  if (!reduced && fine) {
    document.querySelectorAll('.arrival, .portal-stage').forEach((el) => {
      let raf = 0, x = 0, y = 0;
      el.addEventListener('pointermove', (e) => {
        const r = el.getBoundingClientRect();
        x = ((e.clientX - r.left) / r.width - 0.5) * 2;
        y = ((e.clientY - r.top) / r.height - 0.5) * 2;
        if (!raf) raf = requestAnimationFrame(() => { raf = 0; el.style.setProperty('--px', x.toFixed(3)); el.style.setProperty('--py', y.toFixed(3)); });
      }, { passive: true });
      el.addEventListener('pointerleave', () => { el.style.setProperty('--px', 0); el.style.setProperty('--py', 0); });
    });
  }
  document.querySelectorAll('.portal-section').forEach((sec) => {
    const sync = () => {
      const p = sec.querySelector('.portal-panel:not([hidden])') || sec.querySelector('.portal-panel');
      if (p) sec.style.setProperty('--v4-world', getComputedStyle(p).getPropertyValue('--world-accent').trim() || '#7768dd');
    };
    sync();
    new MutationObserver(sync).observe(sec, { subtree: true, attributes: true, attributeFilter: ['hidden', 'aria-selected'] });
  });
})();
